module.exports = __webpack_public_path__ + "static/img/3.672aa91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/3.png
// module id = 5Hk9
// module chunks = 0